import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

import { Observable, of } from 'rxjs';

import { AlertService } from '../alert/alert.service';
import { Router } from '@angular/router';

export type HandleError = <T>(
  operation?: string,
  result?: T
) => (error: HttpErrorResponse) => Observable<T>;

@Injectable({
  providedIn: 'root',
})
export class HttpErrorHandlerService {
  constructor(private alertService: AlertService, private router: Router) {}

  createHandleError =
    (serviceName = '') =>
    <T>(operation = 'operation', result = {} as T) =>
      this.handleError(serviceName, operation, result);

  handleError<T>(serviceName = '', operation = 'operation', result = {} as T) {
    return (error: HttpErrorResponse): Observable<T> => {
      const message =
        error.error && error.error.errors && error.error.errors.length
          ? error.error.errors[0].description
          : error.message;
      this.alertService.add(operation, `Request failed. ${message}`);
      if (error.status === 403) {
        localStorage.removeItem('cm_token');
        localStorage.setItem('redirectTo', this.router.url);
        this.router.navigate(['/login']);
      }
      return of(result);
    };
  }

  handleGraphQLError(error: Array<any>) {
    for (let i = 0; i < error.length; i++) {
      const message = error[i]['message'];
      this.alertService.add('', message);
    }
  }

  handleErrorOld(endpoint: string, error: HttpErrorResponse) {
    const message =
      error.error && error.error.Response && error.error.Response.result
        ? error.error.Response.result.message
        : error.message;
    this.alertService.add(endpoint, `Request failed. ${message}`);
    return of(error);
  }
}
